(function () {
  const SHOW_TOPICS = new Set([
    'Frage zu Bestellung oder Status',
    'Rechnung, Zahlung, Gutschrift',
    'Reklamation',
    'Druckdatencheck, Datenprobleme',
    'Lieferung, Versand, Termin',
    'Angebot, individuelle Druckanfrage'
  ]);

  const PARTNER_TOPIC = 'Partner, Reseller, Kooperation';

  function applyPresetFromUrl(topicSelect) {
    try {
      const params = new URLSearchParams(window.location.search);
      let presetTopic = params.get('thema');
      if (!presetTopic) return false;

      presetTopic = presetTopic.replace(/\+/g, ' ').trim();

      const hasOption = Array.prototype.some.call(topicSelect.options, (opt) => {
        return (opt.value || '').trim() === presetTopic;
      });

      if (!hasOption) return false;

      topicSelect.value = presetTopic;
      return true;
    } catch (e) {
      return false;
    }
  }

  function initConditionalFields(container) {
    const scope = container || document;
    const topicSelects = scope.querySelectorAll('#ContactFormTopic');

    topicSelects.forEach((topicSelect) => {
      if (topicSelect.dataset.cmBound === 'true') return;
      topicSelect.dataset.cmBound = 'true';

      const form = topicSelect.closest('form');
      if (!form) return;

      const orderBox = form.querySelector('#auftragsdaten');
      const standardBox = form.querySelector('#standard-contact-fields');
      const partnerBox = form.querySelector('#partnerdaten');

      const orderInputs = orderBox ? orderBox.querySelectorAll('input, select, textarea') : [];
      const standardInputs = standardBox ? standardBox.querySelectorAll('input, select, textarea') : [];
      const partnerInputs = partnerBox ? partnerBox.querySelectorAll('input, select, textarea') : [];
      const partnerRequired = partnerBox ? partnerBox.querySelectorAll('[data-partner-required="1"]') : [];

      const toggleAll = () => {
        const val = (topicSelect.value || '').trim();
        const isPartner = val === PARTNER_TOPIC;

        // 1) Standardfelder ausblenden bei Partner
        if (standardBox) {
          standardBox.style.display = isPartner ? 'none' : 'block';
          standardBox.setAttribute('aria-hidden', isPartner ? 'true' : 'false');
          standardInputs.forEach((el) => {
            el.disabled = isPartner;
          });
        }

        // 2) Auftragsdaten nur wenn NICHT Partner + Topic matcht
        if (orderBox) {
          const shouldShowOrder = !isPartner && SHOW_TOPICS.has(val);
          orderBox.style.display = shouldShowOrder ? 'block' : 'none';
          orderBox.setAttribute('aria-hidden', shouldShowOrder ? 'false' : 'true');
          orderInputs.forEach((el) => {
            el.disabled = !shouldShowOrder;
          });
        }

        // 3) Partnerfelder nur bei Partner
        if (partnerBox) {
          partnerBox.style.display = isPartner ? 'block' : 'none';
          partnerBox.setAttribute('aria-hidden', isPartner ? 'false' : 'true');

          partnerInputs.forEach((el) => {
            el.disabled = !isPartner;
          });
          partnerRequired.forEach((el) => {
            el.required = isPartner;
          });
        }
      };

      // ✅ 0) Preset aus URL setzen (falls vorhanden)
      const presetApplied = applyPresetFromUrl(topicSelect);

      // 1) Initialer Toggle
      toggleAll();

      // 2) Falls Preset gesetzt wurde: change triggern (für evtl. weitere Listener)
      if (presetApplied) {
        topicSelect.dispatchEvent(new Event('change', { bubbles: true }));
      }

      topicSelect.addEventListener('change', toggleAll);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initConditionalFields());
  } else {
    initConditionalFields();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initConditionalFields(event.target);
  });
})();